import {FC} from 'react'
import {downloadTemplateCompany, uploadMasiveCompany} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'

const MasiveUploadCompany: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadMasiveCompany(formData) // Use the service to upload the file
      return data
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  return (
    <FormMasive
      serviceTemplate={downloadTemplateCompany}
      handleSendService={handleUpload}
      title='Compañia'
    />
  )
}

export {MasiveUploadCompany}
